import { PrimaryBtn } from "../../../buttons"

interface Props {
  takeOverConversation: () => void
}

const AIFooter = ({ takeOverConversation }: Props) => (
  <div className="flex items-center justify-end">
    <span className="text-sm">AI is driving the conversation</span>
    <PrimaryBtn onClick={takeOverConversation} className="ml-4" text="base">
      Take over from AI
    </PrimaryBtn>
  </div>
)

export default AIFooter
